/**
 * Service layer — the compressed design chain (docs/COMPRESSED_CHAIN.md, database/381).
 * Talks to /api/milestone-flow only.
 *
 *   Start ahead   a firm leader lets a milestone begin before a predecessor posts; the link stays.
 *   Post records  "posted with" a later step, and the meeting whose posted minutes hold an approval.
 *
 * Every write announces itself with `milestone-flow-changed` so outline/milestoneFlow.js reloads.
 */

async function authToken() {
  if (typeof window === 'undefined') return null
  for (let i = 0; i < 20; i++) {
    if (typeof window.__clerkGetToken === 'function') {
      try { const t = await window.__clerkGetToken(); if (t) return t } catch { /* not ready */ }
    }
    await new Promise(r => setTimeout(r, 150))
  }
  return null
}
async function post(body) {
  const token = await authToken()
  const res = await fetch('/api/milestone-flow', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}) },
    body: JSON.stringify(body),
  })
  const json = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(json.error || ('Request failed: ' + res.status))
  return json
}
function changed() { if (typeof window !== 'undefined') window.dispatchEvent(new Event('milestone-flow-changed')) }

/** { startAhead: [...], postRecords: [...] } — the whole firm when no projectId. */
export function listMilestoneFlow(projectId) { return post({ action: 'list', projectId: projectId || undefined }) }

/** A firm leader's call: `milestoneId` may begin before `predecessorId` posts. → { row, kitMarked: [names] } */
export async function startAhead({ milestoneId, predecessorId, reason, memberId, memberName }) {
  const r = await post({ action: 'startAhead', milestoneId, predecessorId, reason, memberId, memberName })
  changed(); return r
}

export async function undoStartAhead(id) { const r = await post({ action: 'undoStartAhead', id }); changed(); return r }

/** What a posting said beyond its date. */
export async function recordPost({ milestoneId, postedWithId, postedWithName, meetingId, meetingLabel, quote, note, memberId, memberName }) {
  const r = await post({ action: 'recordPost', milestoneId, postedWithId, postedWithName, meetingId, meetingLabel, quote, note, memberId, memberName })
  changed(); return r
}
